import { render, staticRenderFns } from "./TagViewHeaderBlock.vue?vue&type=template&id=630b5a70"
import script from "./TagViewHeaderBlock.vue?vue&type=script&lang=js"
export * from "./TagViewHeaderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports